import React from "react";

function PrivacySection({
  isPresencePublic = true,
  onIsPresencePublicChange,
}) {
  return (
    <section
      className="ap-pane"
      aria-labelledby="ep-pane-privacy"
      data-section="privacy"
    >
      <header className="ap-pane__head">
        <h2 id="ep-pane-privacy">
          <i className="fa-solid fa-user-shield" aria-hidden="true"></i>
          Приватність
        </h2>
        <p>Керуйте тим, що інші користувачі бачать про вашу активність.</p>
      </header>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="is-presence-public"
              name="is_presence_public"
              data-field="is_presence_public"
              checked={Boolean(isPresencePublic)}
              onChange={(e) => onIsPresencePublicChange?.(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="is-presence-public">
              Показувати іншим, коли я онлайн
            </label>
          </div>
          <small className="form-hint" id="presence-public-hint">
            Якщо вимкнено, інші користувачі не бачитимуть, чи ви зараз онлайн,
            а також час вашої останньої активності.
          </small>
        </div>
      </div>
    </section>
  );
}

export default PrivacySection;
